export const MASCOT_SRC = {
    hero: "/images/mascot/hero-pigeon.webp",
    about: "/images/mascot/about-pigeon.webp",
    why: "/images/mascot/why-pigeon.webp",
    king: "/images/mascot/king-pigeon.webp",
    coin: "/images/mascot/burn-coin.webp",
    rescue: "/images/mascot/rescue-pigeon.webp",
    galleryOg: "/images/mascot/gallery-og.webp",
    galleryTrader: "/images/mascot/gallery-trader.webp",
    galleryKing: "/images/mascot/gallery-king.webp",
    galleryDegen: "/images/mascot/gallery-degen.webp",
    galleryMillion: "/images/mascot/gallery-million.webp",
    galleryStreet: "/images/mascot/gallery-street.webp",
    gallerySolana: "/images/mascot/gallery-solana.webp",
};

const MASCOT_ALT = {
    hero: "BALD PIGEON mascot wearing black sunglasses",
    about: "BALD PIGEON standing tall",
    why: "BALD PIGEON with wings crossed",
    king: "BALD PIGEON wearing a gold crown",
    coin: "Burning $BALD coin with the bald pigeon face",
    rescue: "BALD PIGEON gently holding a rescued baby pigeon",
    galleryOg: "The OG Bald — classic portrait",
    galleryTrader: "The Trader pointing at charts",
    galleryKing: "The King on his throne",
    galleryDegen: "The Degen on a pile of cash",
    galleryMillion: "The Million Club celebrating",
    galleryStreet: "The Street Pigeon in a neon alley",
    gallerySolana: "The Solana Pigeon holding a crystal coin",
};

export default function Mascot({ name, className = "", eager = false, ...rest }) {
    return (
        <img
            src={MASCOT_SRC[name]}
            alt={MASCOT_ALT[name] || "BALD PIGEON mascot"}
            className={className}
            loading={eager ? "eager" : "lazy"}
            decoding="async"
            draggable={false}
            {...rest}
        />
    );
}
